import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Grid, ListItemButton } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { IEventTypeNode } from "source/models/eventType/eventTypeNode";
import { ListLinkValue } from "source/components/framework/List/ListLinkValue";
import { ListStateIconAdd } from "source/components/framework/List/ListStateIconAdd";
import { ListStateIconSuccess } from "source/components/framework/List/ListStateIconSuccess";
import { EllipsisTypography } from "source/components/framework/Typography/EllipsisTypography";

export interface IEventTypeTreeNodeProp {
    classes?: string;
    level: number;
    item: IEventTypeNode;
    selectedId?: string;
    onClick: (id: string) => void;
    onDoubleClick: (id: string) => void;
    onSetCollapsed: (id: string, value: boolean) => void;
}

export class EventTypeTreeNode extends React.Component<IEventTypeTreeNodeProp, {}> {
    handleNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onClick(props.item.id);
    };
    
    handleNodeDoubleClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onDoubleClick(props.item.id);
    };

    render() {
        const props = this.props;
        const item = props.item;
        if (!item || item.parent && item.getAncesterIsCollapsed()) return null;
        const hasChildren = item.children.length > 0;
        const isActive = item.isActive();
        return (
            <>
                <ListItemButton
                    selected={props.selectedId === item.id}
                    onClick={this.handleNodeClick} onDoubleClick={props.onDoubleClick ? this.handleNodeDoubleClick : null}
                    sx={{ bgcolor: !isActive ? "action.hover" : undefined, textDecoration: !isActive ? "line-through !important" : undefined }}
                >
                    <Grid container>
                        <Grid item sm={5} sx={{ paddingLeft: (10 * props.level).toString(10) + "px" }}>
                            <Box display="flex" alignItems="center">
                                {hasChildren
                                    ? (
                                        <>{item.collapsed
                                            ? (
                                                <ChevronRightIcon fontSize="small" onClick={hasChildren ? () => props.onSetCollapsed(item.id, !item.collapsed) : null} />
                                            )
                                            : (
                                                <ExpandMoreIcon fontSize="small" onClick={hasChildren ? () => props.onSetCollapsed(item.id, !item.collapsed) : null} />
                                            )}
                                        </>
                                    )
                                    : (
                                        <Box sx={{ width: "20px" }} />
                                    )}
                                <ListLinkValue onClick={props.onDoubleClick ? this.handleNodeDoubleClick : null}>{item.code}</ListLinkValue>
                            </Box>
                        </Grid>
                        <Grid item sm={5}>
                            <EllipsisTypography>{item.comment}</EllipsisTypography>
                        </Grid>
                        <Grid item sm={2}>
                            {isActive &&
                                <ListStateIconSuccess tooltip={Translations.InUse} />
                            }
                            {isActive && item.isSelectableForNew() &&
                                <ListStateIconAdd color="success" tooltip={Translations.SelectableWhenCreatingAnEvent} />
                            }
                        </Grid>
                    </Grid>
                </ListItemButton>
                {item.children.map((childItem) =>
                    <EventTypeTreeNode
                        key={childItem.id}
                        item={childItem}
                        level={props.level + 1}
                        selectedId={props.selectedId}
                        onClick={props.onClick}
                        onDoubleClick={props.onDoubleClick}
                        onSetCollapsed={props.onSetCollapsed}
                    />
                )}
            </>
        );
    }
}